import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { memo, type ReactNode } from "react";

/** Row of standing information with no control of its own. */
export const SettingsNoteRow = memo(function SettingsNoteRow({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <Flex px="2xl" py="xl" w="full">
      <Text fontSize="xs" fontWeight="regular" textColor="tertiary">
        {children}
      </Text>
    </Flex>
  );
});
